export default __webpack_public_path__ + "static/media/night.3e69fdf5.jpg";